<!-- 优惠券弹窗：内容区相对定位，底部 padding 与商品详情底栏一致，避免被遮挡 -->
<template>
	<!-- eslint-disable vue/no-v-model-argument -- Vant Popup 官方用法为 v-model:show -->
	<van-popup v-model:show="popupShow" position="bottom" :round="true" :z-index="2000" :safe-area-inset-bottom="true" @close="handleClose">
		<div class="wrap">
			<div class="title">
				活动
				<i class="iconfont icon-guanbi close" @click="close"></i>
			</div>
			<div class="content-wrap">
				<div v-if="preferentialData?.activity">
					<span class="cont-title">促销</span>
					<div>
						<span class="tag">{{ formatActivityName(preferentialData.activity.activityType) }}</span>
						<span>{{ preferentialData.activity.desc }}</span>
					</div>
				</div>
				<div>
					<span class="cont-title">领券</span>
					<div class="content rel" v-for="(item, index) of couponList1" :key="'coupon1' + index">
						<div class="flex top start">
							<div class="left">
								<span class="price price-tag">
									<i>¥</i>
									{{ item.couponAmount }}
								</span>
								<span class="font10 price-tag">满{{ item.satisfyAmount }}可用</span>
							</div>
							<div class="right">
								<div class="flex">
									<i class="iconfont icon-dingdan_quan"></i>
									<span style="flex: 1">{{ item.exhibitionNote }}</span>
								</div>
								<span class="date">有效期：{{ formatDate(item.effectiveDate) }} ～ {{ formatDate(item.expirationDate) }}</span>
								<button size="mini" :disabled="item.disabled" class="btn-radius" @click="collectCoupon(item)">领取</button>
							</div>
						</div>
						<span class="coupon-tips">每人限领{{ item.limitProvideNum }}张，数量有限，先到先得。</span>
					</div>
					<div class="content" v-for="(item, index) of couponList2" :key="'coupon2' + index">
						<div class="flex top start">
							<div class="left">
								<span class="price price-tag">
									<i>¥</i>
									{{ item.couponAmount }}
								</span>
								<span class="font10 price-tag">满{{ item.satisfyAmount }}可用</span>
							</div>
							<div class="right">
								<div class="flex">
									<i class="iconfont icon-dingdan_quan"></i>
									<span style="flex: 1">{{ item.exhibitionNote }}</span>
								</div>
								<span class="date">有效期：{{ formatDate(item.effectiveDate) }} ～ {{ formatDate(item.expirationDate) }}</span>
								<i class="ylq iconfont icon-youhuiquantubiao_yilingqu"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</van-popup>
	<!-- eslint-enable vue/no-v-model-argument -->
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import dayjs from 'dayjs';
import { showToast as vantShowToast } from 'vant';
import { collectCoupon as collectCouponApi } from '@/api/goods.js';
import { getStorageSync } from '@/utils/storage.js';

const props = defineProps({
	preferentialData: {
		type: Object,
		default: () => ({}),
	},
});

const emit = defineEmits(['change', 'queryList']);

const popupShow = ref(false);
const couponList1 = ref([]);
const couponList2 = ref([]);
const couponList3 = ref([]);
const couponList4 = ref([]);

const couponList = computed(() => props.preferentialData?.couponList || []);

function classifyCoupons() {
	couponList1.value = [];
	couponList2.value = [];
	couponList3.value = [];
	couponList4.value = [];
	const list = couponList.value;
	list.forEach(item => {
		if (item.provideType == 1) {
			if (item.isReceive > 0) {
				if (item.limitProvideNum > item.isReceive) couponList1.value.push(item);
				if (item.received < item.isReceive) {
					couponList2.value.push(item);
				} else {
					couponList4.value.push(item);
				}
			} else {
				if (item.storageNum === 0) {
					couponList3.value.push(item);
				} else {
					couponList1.value.push(item);
				}
			}
		} else if (item.provideType == 2) {
			if (item.isReceive > 0) couponList2.value.push(item);
		}
	});
	couponList3.value.forEach(item => couponList1.value.push(item));
	couponList4.value.forEach(item => couponList2.value.push(item));
}

watch(couponList, classifyCoupons, { immediate: true });

function open() {
	popupShow.value = true;
}

function close() {
	popupShow.value = false;
}

function handleClose() {
	emit('change', false);
}

function formatDate(date) {
	return dayjs(date).format('YYYY-MM-DD');
}

function formatActivityName(val) {
	switch (val) {
		case 1:
			return '特价';
		case 2:
			return '折扣';
		case 3:
			return '单品促销';
		default:
			return '';
	}
}

async function collectCoupon(item) {
	const getMutil = getStorageSync('getMutil');
	const res = Array.isArray(getMutil) ? getMutil.find(row => row.companyCode === item.companyCode) : null;
	if (!res?.first) {
		vantShowToast({
			message: '因贵司暂未与我方建立首营合作关系，暂无法领取!如有疑问，请咨询平台客服 电话027-59356195。',
			duration: 3000,
			position: 'bottom',
		});
		return;
	}
	if (!getStorageSync('cmdc_access_token_mobile')) {
		window.location.href = '/login';
		return;
	}
	item.disabled = true;
	try {
		const apiRes = await collectCouponApi(item.couponId, item.companyCode);
		item.disabled = false;
		if (apiRes.code === '200') {
			vantShowToast({ message: '领取成功', position: 'bottom' });
			emit('queryList');
		} else {
			vantShowToast({ message: apiRes.message, position: 'bottom' });
		}
	} catch {
		item.disabled = false;
	}
}

defineExpose({ open, close });
</script>

<style lang="scss" scoped>
.wrap {
	position: relative;
	font-size: 1rem;
	background: #fff;
	border-radius: 0.67rem 0.67rem 0 0;
	.title {
		font-size: 1.33rem;
		line-height: 4rem;
		text-align: center;
		color: #222222;
		position: relative;
	}
	.close {
		position: absolute;
		right: 1rem;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
		color: #aaa;
		font-size: 1.2rem;
	}
}
.content-wrap {
	position: relative;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	box-sizing: border-box;
	max-height: calc(100vh - 4rem);
	padding: 0 1rem;
	/* 与详情页 specifications-box 一致：底部 goods-nav-bar 占位 + 安全区，滚到底仍能看到最后一张券 */
	padding-bottom: calc(56px + env(safe-area-inset-bottom));
	> div {
		padding-bottom: 1rem;
	}
	.cont-title {
		display: block;
		padding-bottom: 0.3rem;
		color: #222222;
		font-size: 1.17rem;
		font-weight: 900;
	}
	.tag {
		display: inline-block;
		width: 5.17rem;
		height: 1.5rem;
		line-height: 1.5rem;
		text-align: center;
		margin-right: 1rem;
		border-radius: 0.25rem;
		border: 0.04rem solid #eb3535;
		color: #eb3535;
		font-size: 1rem;
	}
}
.content {
	margin-bottom: 1rem;
	padding-bottom: 0.5rem;
	background: #f9fdfd;
	box-shadow: 0rem 0.17rem 0.33rem 0rem rgba(0, 0, 0, 0.1);
	position: relative;
	.top {
		padding-top: 0.5rem;
	}
	&.rel {
		padding-bottom: calc(2.25rem + 8px);
	}
	&:before {
		content: '';
		display: block;
		height: 0.42rem;
		background: #54c8d0;
		border-radius: 0.5rem 0.5rem 0rem 0rem;
	}
}
.flex {
	display: flex;
	align-items: center;
	&.start {
		align-items: flex-start;
	}
}
.left {
	width: 5rem;
	margin-right: 2rem;
	text-align: center;
	span {
		display: block;
	}
	.price {
		position: relative;
		top: 0.4rem;
		font-size: 2rem;
		font-weight: bold;
		i {
			margin-right: 0.3rem;
			font-style: normal;
			font-size: 1rem;
		}
	}
	.price-tag {
		color: #54c8d0 !important;
		&.font10 {
			position: relative;
			top: -0.2rem;
		}
	}
}
.right {
	position: relative;
	width: calc(100% - 6rem);
	.ylq {
		position: absolute;
		right: 0;
		top: 1rem;
		height: 5rem;
		font-size: 5rem;
		z-index: 99;
		color: #54c8d0;
		transform: rotate(-45deg);
	}
	span {
		display: block;
		margin-bottom: 0.5rem;
		line-height: 1.5rem;
		color: #303133;
	}
}
.btn-radius {
	float: right;
	border-radius: 10rem;
	background: #54c8d0;
	color: #fff;
	border: none;
	padding: 0.25rem 0.75rem;
	cursor: pointer;
	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}
.icon-dingdan_quan {
	position: relative;
	left: -0.8rem;
	top: -0.3rem;
	font-size: 2.4rem;
	color: #eb3535;
}
.date {
	color: rgba(0, 0, 0, 0.5) !important;
}
.coupon-tips {
	position: absolute;
	bottom: 0.5rem;
	left: 1rem;
	right: 1rem;
	color: #777;
	font-size: 0.83rem;
	line-height: 1.3;
}
</style>
